import React from "react"
import Price from "components/Price/Price"
import Availability from "components/Product/Availability"
import LabelSale from "components/Product/LabelSale"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import Typeahead from "components/Typeahead/Typeahead"
import { observer } from "mobx-react"
import * as PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Button, Image, Popup, Table } from "semantic-ui-react"

import quickorderStore from "stores/quickorderStore"

@observer
export default class QuickorderLineItem extends React.Component {


  constructor( props ) {
    super( props )
    this.refCount = React.createRef();
  }

  state = {
    update: false
  }

  handleKeypress = ( event ) => {
    console.log( "KEY", event.key )
  }

  focusCount = () => {
    if ( this.refCount && this.refCount.current) {
      this.refCount.current.focus()
    }
  }

  render() {

    let { lineItem, index, innerRef } = this.props
    const { loading, ready, product, articleNumber } = lineItem
    const hasInvalidId = !product && articleNumber && !loading

    const { warning } = product

    return <Table.Row positive={ready} warning={product && !!product.warning} key={lineItem.map_id + index} className="quickorder-line-item">
      {/* Löschen-Button — auf Mobile oben rechts per CSS positioniert */}
      <Table.Cell className="qli-cell-delete">
        {product && <Button basic icon={"close"} onClick={() => quickorderStore.remove( index )}/>}
      </Table.Cell>

      {/* Positions-Nr. — auf Mobile ausgeblendet */}
      <Table.Cell className="qli-cell-index">
        {1 + index}.
      </Table.Cell>

      {/* Artikel-Nr. / Typeahead */}
      <Table.Cell className="qli-cell-search">
        <Typeahead
          id={this.props.id}
          defaultValue={articleNumber}
          onChange={( { value }, e ) => {
            this.handleKeypress( e )
            quickorderStore.setPosition( index, value )
          }}
          onSelect={value => {
            if (value.product) {
              quickorderStore.setPosition( index, value.product.article_nr )
              setTimeout( () => {
                this.focusCount()
              }, 150 )
            }
          }}
          resultRenderer={entry => {
            return <div>{entry.title}</div>
          }}
          innerRef={innerRef}
        />
      </Table.Cell>

      {/* Produkt-Infos — Bild, Bezeichnung, Art.-Nr., Preis untereinander */}
      <Table.Cell className="qli-cell-product">
        {hasInvalidId && <div className="red f6">
          {translate( "Kein Produkt gefunden" )}
        </div>}
        {product && <div className="qli-product-info">
          <a href={`/product/${product.map_id}/`} target={"_blank"} className="qli-product-img">
            <Image inline src={product.img_src_small} height={40}/>
          </a>
          <div className="qli-product-text">
            <div className="f6 b">{product.desc.des}</div>
            <div className="f7 black-50">{product.article_nr}</div>
            <div className="f6 mt1">
              <Price>{product.price}</Price>
              {product.isSale && <LabelSale price={product.originalPrice} percent={product.salePercent}/>}
            </div>
          </div>
        </div>}
      </Table.Cell>

      {/* Verfügbarkeit */}
      <Table.Cell className="qli-cell-avail">
        {product && <Availability product={product} type={"tiny"}/>}
      </Table.Cell>

      {/* Menge */}
      <Table.Cell className="qli-cell-qty" textAlign={"right"}>
        {product && <div className="qli-qty-wrap">
          <div className="f7 black-50 mb1">{product.unit_multi * product.count} {product.unit_id}</div>
          <ProductQuantityGroup
            showVE={false}
            showHint={true}
            ref={this.refCount}
            className="dib"
            value={product.count}
            onChange={( { product } ) => {
              console.log( { product } )
              quickorderStore.calculate()
              this.setState( { update: true } )
            }}
            onKeyEnter={() => {
              this.props.onFinishPosition && this.props.onFinishPosition()
            }}
            product={product}/>
        </div>}
      </Table.Cell>

      {/* Status-Icon */}
      <Table.Cell className="qli-cell-status">
        <div className="flex justify-center">
          {product.warning && <Popup content={product.warning} trigger={<Button color={"yellow"} icon={"warning circle"} title={product.warning}/>}/>}
          {(product && !product.warning) && <Button basic color={"green"} icon={"check circle"}/>}
        </div>
      </Table.Cell>
    </Table.Row>
  }
}


QuickorderLineItem.propTypes = {
  lineItem: PropTypes.any,
  index   : PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/Quickorder/QuickorderLineItem.js